const customerFilterTypes = {
  set: 'SET_CUSTOMER_FILTER',
  reset: 'RESET_CUSTOMER_FILTER',
}

export const customerFilterActions = {
  /**
   * @param {import("organisms/CustomerFilterGroup/container").CustomerFilter} filter
   */
  set(filter) {
    return {
      type: customerFilterTypes.set,
      filter,
    }
  },
  reset() {
    return {
      type: customerFilterTypes.reset,
    }
  },
}

export default {
  customerFilterActions,
  customerFilterTypes,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/reducers/data/customerFilter/actions.js